import { render } from "./Main.vue?vue&type=template&id=36b44ce8&scoped=true"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"

import "./Main.vue?vue&type=style&index=0&id=36b44ce8&scoped=true&lang=css"

import exportComponent from "/data/www/shoptok-analytics/frontend/live/live_228/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36b44ce8"]])

export default __exports__